<script setup lang="ts">
  import { VRollbackOutlined } from "@krainovsd/vue-icons";
  import { VButton, VDivider } from "@krainovsd/vue-ui";
  import { useUnregisterPushOnLogout } from "@/entities/pwa";
  import { useUsersStore } from "@/entities/users";
  import { OAUTH_PROVIDER } from "@/api";
  import Avatar from "@/components/atoms/Avatar.vue";
  import Field from "@/components/atoms/Field.vue";

  const usersStore = useUsersStore();
  const { unregisterPush } = useUnregisterPushOnLogout();

  function logout() {
    void unregisterPush();
    void OAUTH_PROVIDER.startLogoutFlow();
  }
</script>

<template>
  <div :class="$style.base">
    <div :class="$style.account">
      <Avatar :name="usersStore.currentUser?.email ?? 'A'" size="big" />
      <h1>Account</h1>
    </div>
    <section :class="$style.form">
      <Field label="Имя">
        <span :class="$style.formValue">
          {{ usersStore.currentUser?.name }}
        </span>
      </Field>
      <Field label="Фамилия"><span :class="$style.formValue"></span></Field>
      <Field label="Почта">
        <span :class="$style.formValue">
          {{ usersStore.currentUser?.email }}
        </span>
      </Field>
    </section>
    <VDivider type="horizontal" />
    <VButton size="large" @click="logout">
      <VRollbackOutlined />
      {{ $t("pages.statistics.logout", {}, { default: "Выход" }) }}
    </VButton>
  </div>
</template>

<style lang="scss" module>
  .base {
    width: 100%;
    height: 100%;
    max-height: 100%;
    padding: 80px 16px 48px;
    padding-bottom: 118px;

    overflow: auto;

    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 32px;
  }

  .account {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 12px;
  }

  .form {
    width: 100%;

    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .formValue {
    min-height: 24px;

    font-size: 1rem; //base
    line-height: 1.5rem; //base

    color: var(--foreground);
  }
</style>
